import { OPCOOptions } from '@/types/Services.types';
import styled from '@emotion/styled';
import { rem } from 'polished';

export const ProductHeaderBannerScrollWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${rem('90px')};
  justify-content: center;
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 0px;

  body.has-nav-tabs-sticky & {
    box-shadow: none;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: row;
    align-items: center;
    padding: ${rem('12px')} ${rem('14px')};
  }
`;

export const ProductHeaderBannerScrollInner = styled.div<{ OPCO: string | undefined }>`
  width: 100%;
  max-width: ${({ OPCO }) => (OPCO === OPCOOptions.PORTUGAL ? rem('1048px') : rem('1400px'))};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProductHeaderBannerScrollContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('12px')};
  img {
    border-radius: ${rem('8px')};
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    h4 {
      font-size: ${rem('18px')};
      font-weight: 400;
    }

    max-width: ${rem('178px')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ProductHeaderBannerScrollButton = styled.div<{ OPCO: string | undefined }>`
  margin-left: ${({ OPCO }) => (OPCO === OPCOOptions.PORTUGAL ? 'auto' : 0)};
  padding-right: ${({ OPCO }) => (OPCO === OPCOOptions.PORTUGAL ? rem('60px') : rem('0px'))};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: ${rem('16px')};
    padding-right: ${({ OPCO }) => (OPCO === OPCOOptions.PORTUGAL ? rem('10px') : rem('0px'))};
  }
`;

export const ShowStickyBanner = styled.div<{ sticky?: boolean; offsetTop?: number; OPCO: string | undefined }>`
  position: fixed;
  top: ${({ OPCO, offsetTop = 0 }) => (OPCO === OPCOOptions.PORTUGAL ? rem('70px') : rem(`${offsetTop}px`))};
  left: 0;
  right: 0;
  z-index: 6;
  transform: translateY(${({ sticky }) => (sticky ? '0' : '-100%')});
  transition: transform 0.3s ease-in-out;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    top: ${({ OPCO, offsetTop = 0 }) => (OPCO === OPCOOptions.PORTUGAL ? rem('60px') : rem(`${offsetTop}px`))};
  }
`;
